exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!../../../../styles/workflow.css"), "");

// module
exports.push([module.id, ".processData[data-v-79c3a048]{height:100%}.processData[data-v-79c3a048] .el-card__body{height:calc(100vh - 130px);overflow:auto}.processData[data-v-79c3a048] .el-card__body::-webkit-scrollbar-thumb{-webkit-box-shadow:inset 0 0 6px #ccc}.processData[data-v-79c3a048] .el-card__body::-webkit-scrollbar{width:4px !important}\n", ""]);

// exports
